module.exports = __webpack_public_path__ + "img/festival-400x300.b1455628.jpg";